import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

const WipComponent = () => {
  const { t } = useTranslation();

  const styles: CSSProperties = {
    color: '#f5922b',
  };

  return (
    <div className={'d-flex flex-column align-items-center justify-content-center p-2'} style={styles}>
      <FontAwesomeIcon icon={faCode} size={'8x'} />
      <h2 className={'mt-2 mb-1'}>WORK IN PROGRESS</h2>
      <small className={'text-muted'}>Questa funzionalità è in fase di sviluppo</small>
    </div>
  );
};

export { WipComponent as Wip };
